import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { db } from '../firebase';
import { doc, setDoc } from 'firebase/firestore';

function GoogleSignup() {
  const [nickname, setNickname] = useState('');
  const [agreed, setAgreed] = useState(false);
  const [ageConfirmed, setAgeConfirmed] = useState(false);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { signInWithGoogle } = useAuth();
  const navigate = useNavigate();

  // URLパラメータからGoogleユーザー情報を取得
  const urlParams = new URLSearchParams(window.location.search);
  const googleEmail = urlParams.get('email');
  const googleDisplayName = urlParams.get('displayName') || '';

  React.useEffect(() => {
    // Google表示名をニックネームの初期値として設定
    if (googleDisplayName) {
      setNickname(googleDisplayName);
    }
  }, [googleDisplayName]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!nickname.trim()) {
      setError('ニックネームを入力してください。');
      return;
    }

    if (!agreed) {
      setError('利用規約に同意してください。');
      return;
    }

    if (!ageConfirmed) {
      setError('18歳以上であることを確認してください。');
      return;
    }

    setSubmitting(true);

    try {
      const result = await signInWithGoogle();
      
      // GoogleユーザーのプロフィールをFirestoreに保存
      await setDoc(doc(db, 'users', result.user.uid), {
        email: result.user.email,
        nickname: nickname.trim(),
        createdAt: new Date(),
        bio: '',
        climbingHistory: '',
        favoriteMountains: '',
        yamapLink: '',
        yamarecoLink: '',
        twitterLink: '',
        youtubeLink: '',
        instagramLink: '',
        ageConfirmed: true
      });

      navigate('/profile/edit');
    } catch (error) {
      console.error('Google新規登録に失敗しました:', error);
      setError('Googleアカウントでの登録に失敗しました。');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-container">
      {submitting && (
        <div className="loading-overlay">
          <div className="loading-spinner" />
          登録中...
        </div>
      )}
      <div className="card auth-card">
        <h2 className="text-center mb-4">Googleアカウントで登録</h2>
        
        <div className="google-user-info mb-4">
          <div className="text-center">
            <div className="google-avatar">👤</div>
            <p className="google-email">{googleEmail}</p>
            <p className="text-muted">Googleアカウントでログイン中</p>
          </div>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label required">ニックネーム <span className="required-mark">*</span></label>
            <input
              type="text"
              className="form-control"
              value={nickname}
              onChange={(e) => setNickname(e.target.value)}
              placeholder="ニックネームを入力してください"
              required
              maxLength="20"
            />
            <small className="form-text text-muted">
              最大20文字。山のぼろ内での表示名になります。
            </small>
          </div>
          
          <div className="form-group">
            <label className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                checked={agreed}
                onChange={(e) => setAgreed(e.target.checked)}
                required
              />
              <span className="form-check-label">
                <a href="https://yamano-media.com/blog/terms-of-service/" target="_blank" rel="noopener noreferrer">利用規約</a>・<a href="https://yamano-media.com/blog/policy/" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>に同意します <span className="required-mark">*</span>
              </span>
            </label>
          </div>

          <div className="form-group">
            <label className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                checked={ageConfirmed}
                onChange={(e) => setAgeConfirmed(e.target.checked)}
                required
              />
              <span className="form-check-label">
                18歳以上です <span className="required-mark">*</span>
              </span>
            </label>
          </div>
          
          <button 
            type="submit" 
            className="btn btn-primary w-100"
            disabled={submitting}
          >
            {submitting ? '登録中...' : '登録を完了'}
          </button>
        </form>
        
        <div className="auth-links mt-4">
          <div className="text-center">
            <Link to="/login">ログインはこちら</Link>
          </div>
          <div className="text-center mt-2">
            <Link to="/signup">メールアドレスで登録</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GoogleSignup;
